import { useState } from 'react'
import { Loader2 } from 'lucide-react'

export function LoginPage({ onSuccess }: { onSuccess: () => void }) {
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  async function submit(e: React.FormEvent) {
    e.preventDefault()
    if (!password) return
    setBusy(true)
    setError(null)
    try {
      const res = await fetch('/api/auth/login', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password }),
      })
      if (res.ok) {
        onSuccess()
      } else {
        const d = await res.json().catch(() => ({ error: 'Login failed' }))
        setError((d as { error?: string }).error ?? 'Login failed')
      }
    } catch {
      setError('Network error. Try again.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-surface-page px-6 py-12">
      <div className="w-full max-w-sm flex flex-col items-center">
        <img
          src="/logo.png"
          alt="Deadreckoning"
          className="h-20 sm:h-24 md:h-32 w-auto max-w-[70vw] mb-8 md:mb-12 select-none"
          draggable={false}
        />

        <form onSubmit={submit} className="w-full flex flex-col gap-3">
          <label htmlFor="pw" className="sr-only">Password</label>
          <input
            id="pw"
            type="password"
            autoFocus
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            className="w-full bg-surface-card border border-border rounded-md px-4 py-3 text-base text-ink-primary placeholder:text-ink-tertiary outline-none focus:border-brand-600 focus:ring-1 focus:ring-brand-600 transition"
            disabled={busy}
          />

          {error && (
            <div className="text-status-danger-accent text-sm px-1" role="alert">{error}</div>
          )}

          <button
            type="submit"
            disabled={busy || !password}
            className="w-full bg-brand-600 hover:bg-brand-800 disabled:opacity-60 disabled:cursor-not-allowed text-white rounded-md px-4 py-3 text-base font-medium transition flex items-center justify-center gap-2"
          >
            {busy && <Loader2 className="w-4 h-4 animate-spin" />}
            {busy ? 'Checking…' : 'Enter'}
          </button>
        </form>
      </div>
    </div>
  )
}
